export const DURATION_PRECISION_UNITS = {
    DAYS: ['d'],
    HOURS: ['d', 'h'],
    MINUTES: ['d', 'h', 'm'],
    MINUTES_WITHOUT_DAYS: ['h', 'm'],
    SECONDS: ['d', 'h', 'm', 's']
}
